import { UserModel } from '@/models/db'
import bcrypt from 'bcrypt'
import { NextFunction, Request, Response } from 'express'
import { validationResult } from 'express-validator'

export const registerCtrl = async (
  req: Request,
  res: Response,
  next: NextFunction,
) => {
  const errors = validationResult(req)
  if (!errors.isEmpty()) {
    return res.status(400).json({ errors: errors.array() })
  }
  try {
    const {
      username,
      password,
      email,
      name,
      address,
      phone,
      mobile,
      role,
      city,
      reference,
      notes,
    } = await req.body
    const salt = await bcrypt.genSalt(12)
    const hashedPassword = await bcrypt.hash(password, salt)
    //create user
    const createUser = await UserModel.create({
      data: {
        username,
        password: hashedPassword,
        email,
        name,
        role,
        phone: phone || '',
        address,
        mobile,
        city,
        reference: reference || '',
        notes: notes || '',
      },
    })
    if (!createUser) {
      return res.status(500).json({ message: 'User not created' })
    }
    res.status(201).json({ message: 'User created', data: createUser })
  } catch (err) {
    next(new Error((err as Error).message))
  }
}
